/**
 *
 *@author xujinjiang
 *@date 2022/7/12 13:41
 */
import { BaseServiceImpl } from '@/service/BaseServiceImpl';
import { OrderListUrlConfig } from '@/config/OrderListUrlConfig';

export class OrderListServiceImpl extends BaseServiceImpl {
  private static service: OrderListServiceImpl;

  public static getInstance(): OrderListServiceImpl {
    if (OrderListServiceImpl.service == null) {
      OrderListServiceImpl.service = new OrderListServiceImpl();
    }

    return OrderListServiceImpl.service;
  }

  getOrderList(appKey: string): Promise<any> {
    const option = BaseServiceImpl.getGetOption();
    option.url = OrderListUrlConfig.orderList;
    option.params = {
      appKey: appKey
    };
    return new Promise((resolve, reject) => {
      this
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
